import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import Reveal from './Reveal';
import { APP_LINKS } from '../constants';

const AppShowcase: React.FC = () => {
    const navigate = useNavigate();
    const openDevModal = () => toast('App Android em desenvolvimento. Use a versão Web por enquanto.');
    return (
        <section className="py-24 bg-brand-darkGreen relative overflow-hidden" id="app">

            {/* OTIMIZAÇÃO: Substituição de Blur por Gradient */}
            <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[radial-gradient(circle,rgba(0,104,55,0.4)_0%,rgba(0,0,0,0)_70%)] pointer-events-none translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[radial-gradient(circle,rgba(254,193,14,0.2)_0%,rgba(0,0,0,0)_70%)] pointer-events-none -translate-x-1/2 translate-y-1/2"></div>

            <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="flex flex-col lg:flex-row items-center gap-12 xl:gap-24">

                    <div className="lg:w-1/2 text-white">
                        <Reveal>
                            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-brand-yellow text-xs font-bold uppercase tracking-widest mb-6 backdrop-blur-md">
                                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                                <span>Tecnologia Exclusiva</span>
                            </div>

                            <h2 className="text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-extrabold leading-tight mb-6">
                                O Conselho na <br />
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-yellow to-yellow-200">
                                    Palma da Mão
                                </span>
                            </h2>

                            <div className="text-slate-300 text-lg mb-8 leading-relaxed max-w-xl">
                                <p>Desenvolvemos uma plataforma própria para conectar os 23 municípios. Tenha acesso à legislação, faça inscrições em eventos e envie demandas diretamente para a diretoria regional.</p>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
                                {APP_LINKS.features.map((feature, idx) => (
                                    <div key={idx} className="flex items-start gap-3">
                                        <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center text-brand-yellow shrink-0">
                                            <i className={feature.icon}></i>
                                        </div>
                                        <div>
                                            <h4 className="font-bold text-white text-sm">
                                                <span>{feature.title}</span>
                                            </h4>
                                            <p className="text-slate-400 text-xs leading-snug mt-1">
                                                {feature.desc}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="flex flex-col sm:flex-row gap-4">
                                <button
                                    onClick={openDevModal}
                                    className="flex items-center justify-center gap-3 bg-brand-green hover:bg-green-600 text-white px-8 py-4 rounded-xl font-bold transition-all shadow-[0_4px_14px_0_rgba(37,211,102,0.39)] hover:-translate-y-1 hover:shadow-lg border border-white/10"
                                >
                                    <i className="fab fa-android text-2xl"></i>
                                    <div className="text-left leading-none">
                                        <span className="block text-[10px] uppercase opacity-80">Disponível para</span>
                                        <span className="block text-lg">Android</span>
                                    </div>
                                </button>

                                <button
                                    onClick={() => navigate('/app/login')}
                                    className="flex items-center justify-center gap-3 bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-xl font-bold transition-all border border-white/20 hover:border-brand-yellow/50 backdrop-blur-md"
                                >
                                    <i className="fas fa-globe text-2xl"></i>
                                    <div className="text-left leading-none">
                                        <span className="block text-[10px] uppercase opacity-80">Acesso via</span>
                                        <span className="block text-lg">Navegador</span>
                                    </div>
                                </button>
                            </div>
                            <p className="text-xs text-slate-500 mt-4 ml-1">
                                * Versão iOS em desenvolvimento. Use a versão Web.
                            </p>
                        </Reveal>
                    </div>

                    <div className="lg:w-1/2 flex justify-center lg:justify-end relative scale-90 xl:scale-100">
                        <Reveal delay={200}>
                            <div className="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[550px] xl:h-[600px] w-[280px] xl:w-[300px] shadow-2xl flex flex-col items-center transform will-change-transform hover:scale-[1.01] transition-transform duration-500">

                                <div className="h-[32px] w-[3px] bg-gray-800 absolute -left-[17px] top-[72px] rounded-l-lg"></div>
                                <div className="h-[46px] w-[3px] bg-gray-800 absolute -left-[17px] top-[124px] rounded-l-lg"></div>
                                <div className="h-[46px] w-[3px] bg-gray-800 absolute -left-[17px] top-[178px] rounded-l-lg"></div>
                                <div className="h-[64px] w-[3px] bg-gray-800 absolute -right-[17px] top-[142px] rounded-r-lg"></div>

                                <div className="rounded-[2rem] overflow-hidden w-full h-full bg-slate-50 relative flex flex-col">

                                    <div className="bg-brand-darkGreen h-32 w-full p-6 flex flex-col justify-end rounded-b-3xl shadow-md z-10 relative">
                                        <div className="flex justify-between items-center mb-2">
                                            <i className="fas fa-bars text-white text-lg"></i>
                                            <i className="fas fa-bell text-white text-lg"></i>
                                        </div>
                                        <p className="text-white/80 text-xs">Bem-vindo,</p>
                                        <h3 className="text-white font-bold text-xl">Conselheiro</h3>
                                    </div>

                                    <div className="p-4 space-y-4 overflow-hidden relative">
                                        <div className="flex gap-3 overflow-x-hidden">
                                            <div className="bg-brand-yellow/20 p-3 rounded-xl min-w-[80px] flex flex-col items-center gap-2">
                                                <div className="w-8 h-8 rounded-full bg-brand-yellow flex items-center justify-center text-brand-darkGreen"><i className="fas fa-id-card"></i></div>
                                                <span className="text-[10px] font-bold text-slate-700">Carteira</span>
                                            </div>
                                            <div className="bg-green-100 p-3 rounded-xl min-w-[80px] flex flex-col items-center gap-2">
                                                <div className="w-8 h-8 rounded-full bg-brand-green flex items-center justify-center text-white"><i className="fas fa-map-marker-alt"></i></div>
                                                <span className="text-[10px] font-bold text-slate-700">Mapa</span>
                                            </div>
                                            <div className="bg-slate-100 p-3 rounded-xl min-w-[80px] flex flex-col items-center gap-2">
                                                <div className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center text-white"><i className="fas fa-bullhorn"></i></div>
                                                <span className="text-[10px] font-bold text-slate-700">Ouvidoria</span>
                                            </div>
                                        </div>

                                        <div onClick={openDevModal} className="w-full h-32 bg-gradient-to-r from-brand-darkGreen to-brand-green rounded-2xl p-4 text-white relative overflow-hidden shadow-lg cursor-pointer">
                                            <div className="absolute right-0 top-0 w-24 h-24 bg-white/10 rounded-full -mr-4 -mt-4"></div>
                                            <span className="bg-brand-yellow text-brand-darkGreen text-[8px] font-bold px-2 py-0.5 rounded-full">NOVIDADE</span>
                                            <h4 className="font-bold mt-2">Encontro Regional</h4>
                                            <p className="text-[10px] opacity-80 mb-2">Inscreva-se agora pelo app.</p>
                                            <div className="h-6 w-20 bg-white/20 rounded-md"></div>
                                        </div>

                                        <div className="space-y-2">
                                            <div onClick={openDevModal} className="h-14 w-full bg-white border border-slate-100 rounded-xl shadow-sm flex items-center px-4 gap-3 cursor-pointer">
                                                <div className="w-8 h-8 rounded-full bg-slate-100"></div>
                                                <div className="flex-1">
                                                    <div className="h-2 w-24 bg-slate-200 rounded mb-1"></div>
                                                    <div className="h-2 w-16 bg-slate-100 rounded"></div>
                                                </div>
                                            </div>
                                            <div onClick={openDevModal} className="h-14 w-full bg-white border border-slate-100 rounded-xl shadow-sm flex items-center px-4 gap-3 cursor-pointer">
                                                <div className="w-8 h-8 rounded-full bg-slate-100"></div>
                                                <div className="flex-1">
                                                    <div className="h-2 w-24 bg-slate-200 rounded mb-1"></div>
                                                    <div className="h-2 w-16 bg-slate-100 rounded"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="absolute bottom-0 w-full bg-white h-16 border-t border-slate-100 flex justify-around items-center px-2">
                                        <div onClick={openDevModal} className="flex flex-col items-center gap-1 text-brand-green cursor-pointer"><i className="fas fa-home"></i><span className="text-[8px] font-bold">Início</span></div>
                                        <div onClick={openDevModal} className="flex flex-col items-center gap-1 text-slate-300 cursor-pointer"><i className="fas fa-calendar"></i></div>
                                        <div onClick={openDevModal} className="w-12 h-12 bg-brand-yellow rounded-full -mt-6 border-4 border-slate-50 flex items-center justify-center text-brand-darkGreen shadow-md cursor-pointer"><i className="fas fa-plus"></i></div>
                                        <div onClick={openDevModal} className="flex flex-col items-center gap-1 text-slate-300 cursor-pointer"><i className="fas fa-comment"></i></div>
                                        <div onClick={openDevModal} className="flex flex-col items-center gap-1 text-slate-300 cursor-pointer"><i className="fas fa-user"></i></div>
                                    </div>

                                </div>
                            </div>

                            <div className="absolute top-20 -right-10 bg-white p-4 rounded-xl shadow-xl animate-float z-20 hidden md:block will-change-transform">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600">
                                        <i className="fas fa-check"></i>
                                    </div>
                                    <div>
                                        <p className="text-xs text-slate-400 font-bold uppercase">Status</p>
                                        <p className="font-bold text-slate-800">Inscrição Confirmada</p>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute bottom-40 -left-10 bg-white p-4 rounded-xl shadow-xl animate-float z-20 hidden md:block will-change-transform" style={{ animationDelay: '1s' }}>
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-600">
                                        <i className="fas fa-star"></i>
                                    </div>
                                    <div>
                                        <p className="text-xs text-slate-400 font-bold uppercase">Carteirinha</p>
                                        <p className="font-bold text-slate-800">Ativa</p>
                                    </div>
                                </div>
                            </div>

                        </Reveal>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AppShowcase;
